import moment from 'moment'
import { date, object, string } from 'yup'

export const appointmentSchema = object({
  appointment_at: date()
    .min(moment(new Date()).subtract(1, 'days'), 'Date can not be in the past')
    .required('Date is required'),
  appointment_time: string(),
  patient_id: string().required('Patient ID is required'),
  purpose: string().required('Please provide your reasons for this appointment'),
  staff_id: string()
})

export const editAppointmentSchema = object({
  appointment_at: string().required('Date is required'),
  appointment_time: string(),
  patient_id: string().required('Patient ID is required'),
  purpose: string().required('Please provide your reasons for this appointment'),
  staff_id: string()
})
